var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.2 6.6C1.2 3.622 3.622 1.2 6.6 1.2C9.577 1.2 12 3.622 12 6.6C12 9.578 9.577 12 6.6 12C5.16832 11.9984 3.79573 11.429 2.78338 10.4166C1.77103 9.40427 1.20159 8.03168 1.2 6.6M15.824 14.977L11.668 10.821C12.6589 9.63781 13.2014 8.14334 13.2 6.6C13.2 2.96 10.239 0 6.6 0C2.961 0 0 2.96 0 6.6C0 10.24 2.961 13.2 6.6 13.2C8.14275 13.2007 9.63659 12.6588 10.82 11.669L14.975 15.825C15.0878 15.9361 15.2399 15.9981 15.3981 15.9975C15.5564 15.997 15.7081 15.9339 15.8201 15.8221C15.9321 15.7102 15.9953 15.5586 15.996 15.4003C15.9968 15.2421 15.9349 15.0899 15.824 14.977",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.dd2dd04d3e27858d5087662114c8e711.svg";
export { ForwardRef as ReactComponent };